import { SupplierDetails_supplier } from 'purchaseOrder/view/FormView/__generated__/SupplierDetails';
import { PurchaseOrderValues } from 'purchaseOrder/view/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { SupplierAvailableDocumentTypes } from 'settings/account/supplier/view/ActionMenu/SupplierAttach/__generated__/SupplierAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';
 interface AttachFormProps {
  availableDocumentTypes: SupplierAvailableDocumentTypes | undefined;
  supplier: SupplierDetails_supplier;
}

export const AttachForm: React.FC<AttachFormProps> = ({ supplier, availableDocumentTypes }) => {
  const {
    formState: {
      isDirty
    }
  } = useFormContext<PurchaseOrderValues>();

  return (
    <AttachFormModal
      supplier={supplier}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};

